import React from "react";
import PrivateLayout from "../components/PrivateLayout";

function HomeScreen() {
  return <PrivateLayout>HomeScreen</PrivateLayout>;
}

export default HomeScreen;
